export default __webpack_public_path__ + "static/media/apple-touch-icon.1b373db7.png";